<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">初始化信息</div>
      </div>
      <div>
        <span>果园编号：</span>
        <span>{{ parseStrEmpty(formData.bizNo) }}</span>
      </div>
    </div>
    <el-form :model="formData" ref="form">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园名称：
            <span>{{ parseStrEmpty(formData.name) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            土地性质：
            <span>{{ parseStrEmpty(formData.landName) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            产品名称：
            <span>{{ parseStrEmpty(formData.productName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            施肥种类：
            <span>{{ parseStrEmpty(formData.fertilizerName) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园区域：
            <span>{{ parseStrEmpty(formData.locName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            培育方式：
            <span>{{ parseStrEmpty(formData.cropCultivationMethodName) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            果园定位：
            <span>{{ parseStrEmpty(formData.geoPosDetails) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            果园亩数：
            <span>{{ parseStrEmpty(formData.occupiedArea) }}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            园主/场长：
            <span>{{ parseStrEmpty(formData.ownerName) }}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            联系方式：
            <span>{{ parseStrEmpty(formData.ownerContact) }}</span>
          </span>
        </el-col>
        <el-col :span="24" :xs="24">
          <span class="line">
            备注：
            <span>{{ parseStrEmpty(formData.remark) }}</span>
          </span>
        </el-col>
      </el-row>
    </el-form>
    <div class="title title-mt">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">
          果树信息
          <span class="err">注：信息来源于品控人员的走访记录，仅供参考。</span>
        </div>
      </div>
    </div>

    <div class="topmargin">
      <TablePublic 
        :colLists="colLists" 
        :tableData="formData.crops" 
        :paginationFlag="false"
        :arraySpanMethod="(
          { row, column, rowIndex, columnIndex })=>
            objectSpanMethod(
              { row, column, rowIndex, columnIndex }, 
              formData.crops
            )
          " 
        :showIndex="false"
      >
        <template slot="index" slot-scope="scope">
          <span>{{ customIndex(scope.index) }}</span>
        </template>
      </TablePublic>
    </div>

    <div class="title title-mt">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">农残检测</div>
      </div>
    </div>
    <el-row :gutter="20" class="topmargin">
      <el-col :span="12" :xs="12">
        <span class="line">
          农残检测日期：
          <span>{{ parseStrEmpty(formData.testDate) }}</span>
        </span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12" :xs="12">
        <span class="line">
          农残：
          <span>{{ parseStrEmpty(formData.pesticideTestPassedText) }}</span>
        </span>
      </el-col>
      <el-col :span="12" :xs="12">
        <span class="line">
          重金属：
          <span>{{ parseStrEmpty(formData.heavyMetalTestPassedText) }}</span>
        </span>
      </el-col>
    </el-row>
    <Attachment
      v-if="formData.attachments && formData.attachments.length > 0"
      :fileList="formData.attachments"
      :is-examine="true"
      :isEdit="false"
      :showFileType="false"
    ></Attachment>
    <div v-else class="no-contract-type">暂无内容</div>
    <Box :row="formData"></Box>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { mapState } from 'vuex'
import { getPlantDetail } from '@/api/system/manage'
import TablePublic from '@/components/tablePublic'
import Attachment from '@/components/attachment.vue'
import Box from '@/components/nameBox.vue'
export default {
  components: {
    TablePublic,
    Attachment,
    Box
  },
  data() {
    return {
      colLists: [
        {
          prop: 'index',
          label: '序号',
          isTrue: true,
          width: '55',
          formSolt: true,
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄',
          isTrue: true,
        },
        {
          prop: 'occupiedArea',
          label: '果树亩数',
          isTrue: true,
        },
        {
          prop: 'estimatedTotalOutput',
          label: '预估总产量(斤)',
          isTrue: true,
        },
        {
          prop: 'estimatedUnitPrice',
          label: '预售单价',
          isTrue: true,
        },
        {
          prop: 'availableOrderQuantity',
          label: '可订购量(斤)',
          isTrue: true,
        },
        {
          prop: 'lastUpdateOperator',
          label: '品控人员',
          isTrue: true,
        },
        {
          prop: 'lastVisitDate',
          label: '走访更新时间',
          isTrue: true,
        },
      ],
      tableData: [],
      formData: {},
      spanArr1: [], // 记录每一行的合并数
      pos1: '', // 记录索引
      indexObj: {},// 用于记录索引项对应的实际序号
    }
  },
  computed: {
    ...mapState({ 
      dictList: (state) => state.system.dictList || []
    })
  },
  methods: {
    getDetails(row){
      if(row){
        getPlantDetail(row.id).then(res => {
          if (res.flag) {
            let row = res.data
            let cropCultivationMethodName = ''
            let cropCultivationMethodList = []
            if(row.crops && row.crops.length){
              cropCultivationMethodList = this.uniqueArr(row.crops, 'cultivationMethodSpecValueKey')
              cropCultivationMethodName = cropCultivationMethodList.map(d=>d.cultivationMethodSpecValueKey).join(',')
            }
            this.formData = {
              ...row,
              locName: this.uniqueArr2(row.locDetails.split(',')).join('').replace(/undefined|null/g, ''),
              cropCultivationMethodName: cropCultivationMethodName, //培育方式
              testDate: this.parseTime(row.testDateTime, '{y}-{m}-{d}'),
              productName: this.formatDictToText(row.cropBrandKey,'productType',this.dictList),
              landName: this.formatDictToText(row.fieldTypeKeyList,'landStatus',this.dictList),
              fertilizerName: this.formatDictToText(row.fertilizerTypeKey,'fertilizerType',this.dictList),
              pesticideTestPassedText: CONSTANTS.getStatusConversion(row.pesticideTestPassedStatus, 'pesticideTestPassedStatus'),
              heavyMetalTestPassedText: CONSTANTS.getStatusConversion(row.heavyMetalTestPassedStatus, 'heavyMetalTestPassedStatus'),
              crops: row.crops && row.crops.map(d=>{
                d.lastUpdateOperator = row.lastUpdateOperatorName
                d.lastVisitDate = this.parseTime(row.lastVisitTime, '{y}-{m}-{d}')
                return d
              }) || [],
              attachments: row.cropTestReportAttachments && row.cropTestReportAttachments.map(f=>{
                f.fileName = f.name
                f.fileType = f.type,
                f.fileSuffix = f.name.substring(f.name.lastIndexOf('.') + 1)
                f.fileUrl = f.url
                return f
              }) || []
            }
            this.getSpanArr(this.formData.crops)
          }
        })
      }
    },
    reset() {
    },
    // 合并行
    getSpanArr(data) {
      this.spanArr1 = []
      for (let i = 0; i < data.length; i++) {
        // 第一列
        if (i === 0) {
          this.spanArr1.push(1)
          this.pos1 = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].cultivationMethodSpecValueKey === data[i - 1].cultivationMethodSpecValueKey) {
            this.spanArr1[this.pos1] += 1
            this.spanArr1.push(0)
          } else {
            this.spanArr1.push(1)
            this.pos1 = i
          }
        }
      }
      this.handleIndexObj()
    },
    // 处理indexObj
    handleIndexObj() {
      let num = 0;
      this.spanArr1.forEach((item, index) => {
        if (item !== 0) {
          num++;
          this.indexObj[index] = num;
        }
      });
    },
    // 自定义序号
    customIndex(index) {
      return this.indexObj[index];
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }, list) {
      if(!list || !list.length){
        return
      }
      if ([0, 1].includes(columnIndex)) {
        return {
          rowspan: this.mergeIndexRows(row, list, rowIndex, ['cultivationMethodSpecValueKey']),
          colspan: 1,
        }
      }
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-form-item {
  margin-bottom: 0px;
}
.err {
  color: red;
  margin-left: 10px;
  font-size: 14px;
}
.topmargin {
  margin-top: 20px;
}
.line {
  display: flex;
  word-break: keep-all;
  padding: 8px 0;
  span{
    word-break: break-all;
  }
}
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-top: 10px;
  }
}
</style>